"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeritextCommands = void 0;
const default_1 = require("./default");
class PeritextCommands {
    constructor(txt, et) {
        this.txt = txt;
        this.et = et;
        this.extra = new Map();
        this.exec = (name, ...args) => {
            if (typeof this.def[name] === 'function')
                return this.def[name](...args);
            const cmd = this.extra.get(name);
            if (!cmd)
                throw new Error(`Command ${name} not found`);
            return cmd(...args);
        };
        this.run = (cmds) => {
            if (!Array.isArray(cmds[0]))
                cmds = [cmds];
            const { txt } = this;
            let result;
            for (const [name, ...args] of cmds) {
                result = this.exec(name, ...args);
                txt.refresh();
            }
            return result;
        };
        this.def = new default_1.CommandsImpl(txt, et);
    }
}
exports.PeritextCommands = PeritextCommands;
